import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";
import IpAddressModal from "../../../Modal/IpAddressModal/IpAddressModal";
import { postData } from "../../../utility/Utility";

export default function AddAgentRole() {


    const location = useLocation();
    const userData = location.state || {};

    
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        userId: userData?._id ? userData?._id : "", // Default user ID as per request
        roleType: "User",
        permission: [{
            permissionName: "agentCrmManagement",
            displayName: "Agent CRM Management",
            actions: [],
            allowedIPs: []
        }]
    });

    const [showIpModal, setShowIpModal] = useState(false);
    const [currentPermission, setCurrentPermission] = useState(0);
    const [loading, setLoading] = useState(false);

    const updateActions = (permission, action) => {
        const updatedPermissions = [...formData.permission];
        const permIndex = updatedPermissions.findIndex(p => p.permissionName === permission);

        if (permIndex >= 0) {
            if (updatedPermissions[permIndex].actions.includes(action)) {
                updatedPermissions[permIndex].actions = updatedPermissions[permIndex].actions.filter(a => a !== action);
            } else {
                updatedPermissions[permIndex].actions = [...updatedPermissions[permIndex].actions, action];
            }
            setFormData({ ...formData, permission: updatedPermissions });
        } else {
            setFormData({
                ...formData,
                permission: [
                    ...formData.permission,
                    { permissionName: permission, actions: [action], allowedIPs: [] }
                ]
            });
        }
    };

    const handleSelectIps = (selectedIps) => {
        const updatedPermissions = [...formData.permission];

        // Ensure we always have an array of IP strings
        const ipList = Array.isArray(selectedIps)
            ? selectedIps.map(ip => typeof ip === 'string' ? ip : ip.ipAddress)
            : [typeof selectedIps === 'string' ? selectedIps : selectedIps.ipAddress];

        // Merge with existing IPs and remove duplicates
        updatedPermissions[currentPermission].allowedIPs = [
            ...new Set([
                ...updatedPermissions[currentPermission].allowedIPs,
                ...ipList
            ])
        ];

        setFormData({ ...formData, permission: updatedPermissions });
        setShowIpModal(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const payload = {
                userId: formData.userId,
                roleType: formData.roleType,
                permission: formData.permission
                    .filter(p => p.actions.length > 0)
            };

            const response = await postData("api/permissions", payload);

            if (response?.success) {
                toast.success("Role created successfully");
                navigate("/role-list");
            } else {
                toast.error(response?.message || "Failed to create role");
            }
        } catch (error) {
            toast.error(error.message || "Error creating role");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="content-page">
            <CustomLoader loading={loading} />
            <ToastContainer position="top-right" autoClose={5000} />
            
      
            
            {/* Rest of your existing form */}
            <IpAddressModal
                show={showIpModal}
                onClose={() => setShowIpModal(false)}
                onSelect={handleSelectIps}
            />
            <div className="content">
                <div className="container-fluid">
                    <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
                        <div className="flex-grow-1 mb-2 mb-sm-0">
                            <h4 className="fs-18 fw-semibold m-0">Add Role</h4>
                        </div>
                        <div>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate(-1)}
                            >
                                Back
                            </button>
                        </div>
                    </div>



                    {/* Enhanced User Info Section */}
                    <div className="card mb-4">
                        <div className="card-header bg-primary text-white">
                            <h5 className="mb-0">Agent Information</h5>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-2 text-center">
                                    <img
                                        src={userData.image}
                                        alt={userData.fullName}
                                        className="rounded-circle img-thumbnail mb-3"
                                        width="120"
                                        height="120"
                                    />
                                    <div className="badge bg-info">{userData.uniqueId}</div>
                                </div>

                                <div className="col-md-10">
                                    <div className="row g-3">
                                        <div className="col-md-4">
                                            <div className="info-item">
                                                <small className="text-muted">Full Name</small>
                                                <h6>{userData.fullName}</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="info-item">
                                                <small className="text-muted">Email</small>
                                                <h6>{userData.email}</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="info-item">
                                                <small className="text-muted">Mobile</small>
                                                <h6>{userData.mobile}</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="info-item">
                                                <small className="text-muted">Status</small>
                                                <span className={`badge ms-1 text-capitalize ${userData.status === 'active' ? 'bg-success' : 'bg-danger'}`}>
                                                    {userData.status}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="info-item">
                                                <small className="text-muted">Designation</small>
                                                <h6>{userData.role || userData.designation}</h6> 
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="info-item">
                                                <small className="text-muted">Join Date</small>
                                                <h6>{new Date(userData.createdAt).toLocaleDateString()}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <form onSubmit={handleSubmit}>
                             

                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card-header mb-3">
                                                <h5 className="card-title mb-0">Permissions</h5>
                                            </div>

                                            <div className="row">
                                                {formData.permission.map((permission, index) => (
                                                    <div key={index} className="col-12 mb-4">
                                                        <div className="card permission-card">
                                                            <div className="card-header bg-light">
                                                                <h6 className="mb-0">{permission.displayName}</h6>
                                                            </div>
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-md-2 col-6 mb-2">
                                                                        <div className="form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                id={`read-${index}`}
                                                                                checked={permission.actions.includes('read')}
                                                                                onChange={() => updateActions(permission.permissionName, 'read')}
                                                                            />
                                                                            <label className="form-check-label" htmlFor={`read-${index}`}>
                                                                                Read
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2 col-6 mb-2">
                                                                        <div className="form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                id={`write-${index}`}
                                                                                checked={permission.actions.includes('write')}
                                                                                onChange={() => updateActions(permission.permissionName, 'write')}
                                                                            />
                                                                            <label className="form-check-label" htmlFor={`write-${index}`}>
                                                                                Write
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2 col-6 mb-2">
                                                                        <div className="form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                id={`update-${index}`}
                                                                                checked={permission.actions.includes('update')}
                                                                                onChange={() => updateActions(permission.permissionName, 'update')}
                                                                            />
                                                                            <label className="form-check-label" htmlFor={`update-${index}`}>
                                                                                Update
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2 col-6 mb-2">
                                                                        <div className="form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                id={`delete-${index}`}
                                                                                checked={permission.actions.includes('delete')}
                                                                                onChange={() => updateActions(permission.permissionName, 'delete')}
                                                                            />
                                                                            <label className="form-check-label" htmlFor={`delete-${index}`}>
                                                                                Delete
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-6 mb-2">
                                                                        <button
                                                                            className="btn btn-primary"
                                                                            onClick={() => {
                                                                                setCurrentPermission(index);
                                                                                setShowIpModal(true);
                                                                            }}
                                                                            type="button"
                                                                        >
                                                                            {permission.allowedIPs.length > 0
                                                                                ? `${permission.allowedIPs.length} IPs selected`
                                                                                : 'Select IPs'}
                                                                        </button>

                                                                        {permission.allowedIPs.length > 0 && (
                                                                            <div className="mt-2">
                                                                                <small>Selected IPs:</small>
                                                                                <div className="d-flex flex-wrap gap-1">
                                                                                    {permission.allowedIPs.map(ip => (
                                                                                        <span key={ip} className="badge bg-primary">
                                                                                            {ip}
                                                                                        </span>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="mt-4 d-flex justify-content-end">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    disabled={loading}
                                                    style={{ minWidth: "120px" }}
                                                >
                                                    Add Role
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
